import React from "react";
import { useMercuryContext } from "../../context/index";
import Cookies from "js-cookie";
import { Button } from "antd";
import { LogoutOutlined } from "@ant-design/icons";
import { performAuth0Logout } from "../authHelpers";

const LogoutButton = () => {
    const context = useMercuryContext();
    const { removeToken } = context;

    const handleLogout = () => {
        if (!document.location.pathname.includes("logout")) {
            Cookies.set("return_url", document.location.pathname);
        }

        try {
            // Redirect to Auth0 first; local cookie/session cleanup happens on
            // the /logout return leg (LogoutRedirect).
            performAuth0Logout();
        } catch (e) {
            console.error("Auth0 logout failed, fallback to local logout", e);
            removeToken();
            window.location.href = "/logout";
        }
    };

    return (
        <Button
            type="text"
            icon={<LogoutOutlined />}
            onClick={handleLogout}
            className="profile-menu-item profile-menu-item__logout"
        >
            Log Out
        </Button>
    );
};

export default LogoutButton;
